import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    if (!message || typeof message !== 'string' || !message.trim()) return;
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, duration);
  }, []);

  // Иконки и стили для разных типов
  const toastTypeConfig = {
    success: {
      icon: '✔️',
      bg: 'linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)',
      color: '#155724',
    },
    error: {
      icon: '❌',
      bg: 'linear-gradient(90deg, #f85032 0%, #e73827 100%)',
      color: '#721c24',
    },
    info: {
      icon: 'ℹ️',
      bg: 'linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)',
      color: '#0c5460',
    },
    warning: {
      icon: '⚠️',
      bg: 'linear-gradient(90deg, #f7971e 0%, #ffd200 100%)',
      color: '#856404',
    },
    default: {
      icon: '🔔',
      bg: 'linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)',
      color: '#333',
    },
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container-modern">
        {toasts.map(toast => {
          const cfg = toastTypeConfig[toast.type] || toastTypeConfig.default;
          return (
            <div 
              key={toast.id} 
              className={`toast-modern toast-${toast.type}`}
              style={{
                background: cfg.bg,
                color: cfg.color,
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                borderRadius: 12,
                minWidth: 220,
                maxWidth: 340,
                marginBottom: 16,
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                fontSize: 16,
                fontWeight: 500,
                animation: 'slideInRightModern 0.4s cubic-bezier(.4,2,.6,1)'
              }}
            >
              <span style={{ fontSize: 24, marginRight: 16 }}>{cfg.icon}</span>
              <span style={{ flex: 1 }}>{toast.message}</span>
            </div>
          );
        })}
      </div>
      <style>{`
        .toast-container-modern {
          position: fixed;
          top: 32px;
          right: 32px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
        @keyframes slideInRightModern {
          0% { opacity: 0; transform: translateX(120%); }
          60% { opacity: 1; transform: translateX(-8%); }
          100% { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </ToastContext.Provider>
  );
}; 